import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class OnboardingInitialExtensionCheckUnsupportedBrowserError extends BaseEitherError {}

export class OnboardingInitialExtensionCheckError extends BaseEitherError {}

export type TOnboardingInitialExtensionCheckOperationErrors =
  | OnboardingInitialExtensionCheckUnsupportedBrowserError
  | OnboardingInitialExtensionCheckError;
